import { Label } from '@components/ui/label';

import { useHidratacaoQueimado } from '../context';
import Item from './Item';

function CalculateSQC() {
  const { areas, SCQTotal } = useHidratacaoQueimado();

  return (
    <div className="flex flex-col items-center space-y-4">
      <div className="ml-48 flex flex-row gap-4">
        <Label>Acometido?</Label>
        <Label>Porcent.</Label>
      </div>
      {areas.map((area) => (
        <Item data={area} key={area.id} />
      ))}

      <Label className="ml-34 mt-4 text-lg font-bold">{`Total SCQ: ${SCQTotal.toFixed(1)}%`}</Label>
    </div>
  );
}
export default CalculateSQC;
